import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
const FILTER_DEFAULTS = {
    brightness: 1,
    contrast: 1,
    opacity: 1,
};
const FILTER_CONFIG = {
    brightness: { min: 0, max: 2, step: 0.1, label: 'Яркость' },
    contrast: { min: 0, max: 2, step: 0.05, label: 'Контрастность' },
    opacity: { min: 0, max: 1, step: 0.01, label: 'Прозрачность' },
};
/**
 * Создает объект фильтров, включая только не-дефолтные значения.
 */
function createFiltersObject(values) {
    const filters = {};
    let hasNonDefault = false;
    for (const key of ['brightness', 'contrast', 'opacity']) {
        if (values[key] !== FILTER_DEFAULTS[key]) {
            filters[key] = values[key];
            hasNonDefault = true;
        }
    }
    return hasNonDefault ? filters : null;
}
/**
 * Попап для редактирования фильтров изображения рядом с кнопкой.
 */
export const ImageFiltersPopover = ({ isOpen, onClose, element, onFiltersChange, onFiltersChangeDebounced, buttonRef, }) => {
    const filtersPopupRef = useRef(null);
    const [filters, setFilters] = useState(Object.assign({}, FILTER_DEFAULTS));
    const debouncedSendFilters = useDebouncedCallback((filters) => {
        onFiltersChangeDebounced(filters);
    }, 300);
    // Инициализация значений фильтров из элемента
    useEffect(() => {
        var _a, _b, _c, _d;
        if ((_a = element === null || element === void 0 ? void 0 : element.props) === null || _a === void 0 ? void 0 : _a.filters) {
            setFilters({
                brightness: (_b = element.props.filters.brightness) !== null && _b !== void 0 ? _b : FILTER_DEFAULTS.brightness,
                contrast: (_c = element.props.filters.contrast) !== null && _c !== void 0 ? _c : FILTER_DEFAULTS.contrast,
                opacity: (_d = element.props.filters.opacity) !== null && _d !== void 0 ? _d : FILTER_DEFAULTS.opacity,
            });
        }
        else {
            setFilters(Object.assign({}, FILTER_DEFAULTS));
        }
    }, [element, isOpen]);
    const handleFilterChange = (key, value) => {
        const newFilters = Object.assign(Object.assign({}, filters), { [key]: value });
        setFilters(newFilters);
        const filtersObject = createFiltersObject(newFilters);
        onFiltersChange(filtersObject);
        debouncedSendFilters(filtersObject);
    };
    const handleReset = () => {
        const defaultFilters = Object.assign({}, FILTER_DEFAULTS);
        setFilters(defaultFilters);
        const filtersObject = createFiltersObject(defaultFilters);
        onFiltersChange(filtersObject);
        debouncedSendFilters(filtersObject);
    };
    if (!isOpen)
        return null;
    return (_jsxs("div", { ref: filtersPopupRef, style: {
            position: 'fixed',
            bottom: 0,
            left: '50%',
            transform: 'translate(0%, -80px)',
            zIndex: 1000,
            minWidth: 260,
            borderRadius: 8,
            padding: 16,
            background: '#1D2024EE',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }, children: [_jsx("h3", { style: { marginTop: 0, marginBottom: 16, fontSize: 16, color: '#BDC2C5' }, children: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F" }), Object.keys(FILTER_CONFIG).map((key) => {
                const config = FILTER_CONFIG[key];
                return (_jsx("div", { style: { marginBottom: 10 }, children: _jsxs("label", { style: { display: 'block', marginBottom: 2 }, children: [_jsx("div", { style: { display: 'flex', justifyContent: 'space-between', marginBottom: 2 }, children: _jsxs("span", { style: { fontSize: 14, color: '#86898B', fontWeight: 600 }, children: [config.label, ":", ' ', _jsx("span", { style: { color: '#C0C3C5' }, children: filters[key].toFixed(2) })] }) }), _jsx("input", { type: "range", min: config.min, max: config.max, step: config.step, value: filters[key], onChange: (e) => handleFilterChange(key, parseFloat(e.target.value)), style: { width: '100%' }, "aria-label": config.label })] }) }, key));
            }), _jsx("div", { style: { display: 'flex', justifyContent: 'flex-end' }, children: _jsx("button", { type: "button", onClick: handleReset, style: {
                        padding: '6px 12px',
                        border: '1px solid #3a4045',
                        borderRadius: 4,
                        background: '#2e3136',
                        cursor: 'pointer',
                        fontSize: 14,
                    }, children: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C" }) })] }));
};
